import { t } from '#shared/utils/locales'

export default function () {
  const toast = useToast()

  const { data } = getData()

  function waitProgressLoading() {
    toast.add({
      color: 'primary',
      title: 'Vennligst vent',
      description: 'Vi lagrer fortsatt dine endringer',
      duration: 3000,
    })
  }

  function showError() {
    toast.add({
      color: 'error',
      title: t('forms.error.title'),
      description: t('forms.error.description', { email: data.ngo.email }),
      duration: 3000,
    })
  }

  return {
    waitProgressLoading,
    showError,
  }
}
